import * as types from './types';

const getPostingLastStep = idPost => ({
  type: types.GET_POSTING_LAST_STEP,
  meta: {
    async: true,
    blocking: false,
    api: 'publicador',
    path: `/publicador/api/v1/postings/stepper/${idPost}`,
    method: 'GET'
  }
});

const updateLastStep = (step, module) => ({
  type: types.UPDATE_LAST_STEP,
  payload: {
    step,
    module
  }
});

export { getPostingLastStep, updateLastStep };
